import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";
const ProcurementRecieptForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [rejectdisabled, SetRejectdisabled] = useState(false);

  const [employeeId, setEmployeeId] = useState(null);
  const [employeelist, setEmployeelist] = useState(null);

  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const [gatepassId, setGatePassId] = useState();
  const [getpassData, setgetpassData] = useState([]);

  const [getpassproductdata, setgetpassproductdata] = useState([]);
  const [procurmentProductdata, setprocurmentProductdata] = useState([]);
  const [totalProcuredQuantity, settotalProcuredQuantity] = useState();
  const [totalProcuredQuantityUnit, settotalProcuredQuantityUnit] = useState();
  const [totalProcuredQuantityUnitId, settotalProcuredQuantityUnitId] =
    useState();
  const [currencyCode, setCurrencyCode] = useState(
    localStorage.getItem("currencyCode")
  );

  const [loading, setLoading] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  var d = new Date();

  const { sendRequest: getGatePass } = useHttp();
  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getpass } = useHttp();
  useEffect(() => {
    getpass(
      {
        url: `/api/getpasForProcurementReciept/`,
      },
      (res) => {
        if (res) {
          //console.log("gatePass", res);
          setgetpassData(res);
        }
      }
    );
  }, [getpass]);

  const { sendRequest: getGetpassData } = useHttp();

  const loadgetpassData = (id) => {
    setProductDetails([]);
    setGatePassId(id);

    getGetpassData(
      {
        url: `/api/getGetPassProductDetails/?gatepassId=${id}`,
      },
      (res) => {
        //console.log("getpassproductdata", res);
        setgetpassproductdata(res.getpassDetail);

        var itemlist = getpassData.filter(
          (item) => parseInt(item.gatepassId) == parseInt(id)
        );

        frmRef.current.farmerType.value = itemlist[0].getpassType;
        frmRef.current.farmerName.value = itemlist[0].getPassForName;
        frmRef.current.procurementNo.value = itemlist[0].docNoFor;

        //console.log("itemlist", itemlist[0].docNoFor);

        if (
          itemlist[0].getpassType == "Existing Farmer" ||
          itemlist[0].getpassType == "Employee"
        ) {
          setprocurmentProductdata(res.getpassDetail);
          console.log(res.getpassDetail);
          frmRef.current.reject_procurement.checked = false;
          frmRef.current.reject_procurement.disabled = true;

          rjdis = true;
        } else {
          frmRef.current.reject_procurement.disabled = false;
          var rjdis = false;
        }

        SetRejectdisabled(rjdis);

        //  // //console.log("work order", data);
        //   frmRef.current.labour_count.value = data.labourCount;
        //   frmRef.current.labour_cost.value = data.labourCost;
        //   frmRef.current.labour_transport_cost.value = data.labourTransportCost;
        //   frmRef.current.labour_meal_cost.value = data.labourMealCost;
        //   frmRef.current.lineTotalAmount.value = data.lineTotalAmount || 0;
        //   frmRef.current.taxAmount.value = data.taxAmount || 0;
        //   frmRef.current.discountPercentage.value = data.discountPercentage || 0;
        //   frmRef.current.discountAmount.value = data.discountAmount || 0;
        //   frmRef.current.total_amount.value = data.totalAmount;
        //   frmRef.current.totalWorkOrderAmount.value = data.totalWorkOrderAmount;
      }
    );
  };

  const calculateTotalProcuredQuantity = (vlist) => {
    var i = 0;
    var totalProcuredQuantity = 0;
    var k = 0;
    console.log("calculateTotalProcuredQuantity", vlist);
    do {
      k = k + 1;
      //console.log("itemQuantity", vlist && vlist[i].itemQuantity);
      totalProcuredQuantity =
        totalProcuredQuantity +
        parseFloat(
          vlist && vlist[i].itemQuantity == "" ? "0" : vlist[i].itemQuantity
        );

      i++;
    } while (vlist.length > i);

    settotalProcuredQuantityUnit("Kg");
    settotalProcuredQuantityUnitId(2);

    //console.log("totalProcuredQuantity", totalProcuredQuantity);
    settotalProcuredQuantity(totalProcuredQuantity);
  };

  const { sendRequest: getproductgradedetail } = useHttp();

  const addToProcurmentList = () => {
    var i = 0;
    var k = 0;
    var newList = [];

    getproductgradedetail(
      {
        url: `/api/productData/?cropData=crop&&varietyId=${getpassproductdata[i].varietyId}`,
      },
      (res) => {
        //console.log("getproductgradedetail", res);

        console.log("getpassproductdata", getpassproductdata);

        if (getpassproductdata.length>1)
          {
 

        do {
          k = k + 1;

          //Grade 1
          var itemlistclass1 = res.filter(
            (item) =>
              parseInt(item.varietyId) ==
                parseInt(
                  getpassproductdata && getpassproductdata[i].varietyId
                ) &&
              parseInt(item.gradeId) > 0 &&
              item.gradeName.toLowerCase() == "grade 1" &&
              parseInt(item.inputproductId || 0) == 0
          );

          //console.log("itemlistclass1", itemlistclass1);

          newList = newList.concat({
            linesrno: k,
            gatepassdetailId:
              getpassproductdata && getpassproductdata[i].gatepassdetailId,
            unitAbbreviation:
              getpassproductdata && getpassproductdata[i].unitAbbreviation,
            cropName: getpassproductdata && getpassproductdata[i].cropName,
            varietyName:
              getpassproductdata && getpassproductdata[i].varietyName,
            itemQuantity:
              getpassproductdata && getpassproductdata[i].itemQuantity,

            gradeName: getpassproductdata && getpassproductdata[i].gradeName,
            productName:
              getpassproductdata && getpassproductdata[i].productName,

            procurementQuantity:
              getpassproductdata && getpassproductdata[i].procurementQuantity,
            rate: (getpassproductdata && getpassproductdata[i].rate) ?? 0,
            status: getpassproductdata && getpassproductdata[i].status,
            createdDate:
              getpassproductdata && getpassproductdata[i].createdDate,
            gatepassId: getpassproductdata && getpassproductdata[i].gatepassId,
            cropId: getpassproductdata && getpassproductdata[i].cropId,
            varietyId: getpassproductdata && getpassproductdata[i].varietyId,
            productId: itemlistclass1[0].productId, //getpassproductdata && getpassproductdata[i].productId,
            gradeId: getpassproductdata && getpassproductdata[i].gradeId,
            unitId: getpassproductdata && getpassproductdata[i].unitId,
            orgId: getpassproductdata && getpassproductdata[i].orgId,
            createdBy: getpassproductdata && getpassproductdata[i].createdBy,
          });
          k = k + 1;
          i++;

          //Grade 2
          var itemlistclass2 = res.filter(
            (item) =>
              parseInt(item.varietyId) ==
                parseInt(
                  getpassproductdata && getpassproductdata[i].varietyId
                ) &&
              parseInt(item.gradeId) > 0 &&
              parseInt(item.inputproductId || "0") == 0 &&
              item.gradeName.toLowerCase() == "grade 2"
          );

          newList = newList.concat({
            linesrno: k,
            gatepassdetailId:
              getpassproductdata && getpassproductdata[i].gatepassdetailId,
            unitAbbreviation:
              getpassproductdata && getpassproductdata[i].unitAbbreviation,
            cropName: getpassproductdata && getpassproductdata[i].cropName,
            varietyName:
              getpassproductdata && getpassproductdata[i].varietyName,
            itemQuantity:
              getpassproductdata && getpassproductdata[i].itemQuantity,
            gradeName: getpassproductdata && getpassproductdata[i].gradeName,
            productName:
              getpassproductdata && getpassproductdata[i].productName,
            procurementQuantity:
              getpassproductdata && getpassproductdata[i].procurementQuantity,
            rate: (getpassproductdata && getpassproductdata[i].rate) ?? 0,
            status: getpassproductdata && getpassproductdata[i].status,
            createdDate:
              getpassproductdata && getpassproductdata[i].createdDate,
            gatepassId: getpassproductdata && getpassproductdata[i].gatepassId,
            cropId: getpassproductdata && getpassproductdata[i].cropId,
            varietyId: getpassproductdata && getpassproductdata[i].varietyId,
            productId: itemlistclass2[0].productId, //getpassproductdata && getpassproductdata[i].productId,
            gradeId: getpassproductdata && getpassproductdata[i].gradeId,
            unitId: getpassproductdata && getpassproductdata[i].unitId,
            orgId: getpassproductdata && getpassproductdata[i].orgId,
            createdBy: getpassproductdata && getpassproductdata[i].createdBy,
          });

          k = k + 1;
          i++;
          //Grade 3
          var itemlistclass3 = res.filter(
            (item) =>
              parseInt(item.varietyId) ==
                parseInt(
                  getpassproductdata && getpassproductdata[i].varietyId
                ) &&
              parseInt(item.gradeId) > 0 &&
              parseInt(item.inputproductId || "0") == 0 &&
              item.gradeName.toLowerCase() == "grade 3"
          );

          newList = newList.concat({
            linesrno: k,
            gatepassdetailId:
              getpassproductdata && getpassproductdata[i].gatepassdetailId,
            unitAbbreviation:
              getpassproductdata && getpassproductdata[i].unitAbbreviation,
            cropName: getpassproductdata && getpassproductdata[i].cropName,
            varietyName:
              getpassproductdata && getpassproductdata[i].varietyName,
            itemQuantity:
              getpassproductdata && getpassproductdata[i].itemQuantity,
            gradeName: getpassproductdata && getpassproductdata[i].gradeName,
            productName:
              getpassproductdata && getpassproductdata[i].productName,
            procurementQuantity:
              getpassproductdata && getpassproductdata[i].procurementQuantity,
            rate: (getpassproductdata && getpassproductdata[i].rate) ?? 0,
            status: getpassproductdata && getpassproductdata[i].status,
            createdDate:
              getpassproductdata && getpassproductdata[i].createdDate,
            gatepassId: getpassproductdata && getpassproductdata[i].gatepassId,
            cropId: getpassproductdata && getpassproductdata[i].cropId,
            varietyId: getpassproductdata && getpassproductdata[i].varietyId,
            productId: itemlistclass3[0].productId, //getpassproductdata && getpassproductdata[i].productId,
            gradeId: getpassproductdata && getpassproductdata[i].gradeId,
            unitId: getpassproductdata && getpassproductdata[i].unitId,
            orgId: getpassproductdata && getpassproductdata[i].orgId,
            createdBy: getpassproductdata && getpassproductdata[i].createdBy,
          });

          k = k + 1;
          i++;
          //Grade 4
          var itemlistclass3 = res.filter(
            (item) =>
              parseInt(item.varietyId) ==
                parseInt(
                  getpassproductdata && getpassproductdata[i].varietyId
                ) &&
              parseInt(item.gradeId) > 0 &&
              parseInt(item.inputproductId || "0") == 0 &&
              item.gradeName.toLowerCase() == "grade 4"
          );

          newList = newList.concat({
            linesrno: k,
            gatepassdetailId:
              getpassproductdata && getpassproductdata[i].gatepassdetailId,
            unitAbbreviation:
              getpassproductdata && getpassproductdata[i].unitAbbreviation,
            cropName: getpassproductdata && getpassproductdata[i].cropName,
            varietyName:
              getpassproductdata && getpassproductdata[i].varietyName,
            itemQuantity:
              getpassproductdata && getpassproductdata[i].itemQuantity,
            gradeName: getpassproductdata && getpassproductdata[i].gradeName,
            productName:
              getpassproductdata && getpassproductdata[i].productName,
            procurementQuantity:
              getpassproductdata && getpassproductdata[i].procurementQuantity,
            rate: (getpassproductdata && getpassproductdata[i].rate) ?? 0,
            status: getpassproductdata && getpassproductdata[i].status,
            createdDate:
              getpassproductdata && getpassproductdata[i].createdDate,
            gatepassId: getpassproductdata && getpassproductdata[i].gatepassId,
            cropId: getpassproductdata && getpassproductdata[i].cropId,
            varietyId: getpassproductdata && getpassproductdata[i].varietyId,
            productId: itemlistclass3[0].productId, //getpassproductdata && getpassproductdata[i].productId,
            gradeId: getpassproductdata && getpassproductdata[i].gradeId,
            unitId: getpassproductdata && getpassproductdata[i].unitId,
            orgId: getpassproductdata && getpassproductdata[i].orgId,
            createdBy: getpassproductdata && getpassproductdata[i].createdBy,
          });

          i++;
          console.log("i ", i);
        } while (getpassproductdata.length > i);
      }
        else
      {
        var itemlistclass1 = res.filter(
          (item) =>
            parseInt(item.varietyId) ==
              parseInt(
                getpassproductdata && getpassproductdata[i].varietyId
              ) &&
            parseInt(item.gradeId) > 0 &&
            item.gradeName.toLowerCase() == "grade 1" &&
            parseInt(item.inputproductId || 0) == 0
        );
 
 
        newList = newList.concat({
          linesrno: 1,
          gatepassdetailId:
            getpassproductdata && getpassproductdata[i].gatepassdetailId,
          unitAbbreviation:
            getpassproductdata && getpassproductdata[i].unitAbbreviation,
          cropName: getpassproductdata && getpassproductdata[i].cropName,
          varietyName:
            getpassproductdata && getpassproductdata[i].varietyName,
          itemQuantity: getpassproductdata && getpassproductdata[i].itemQuantity,
           
          gradeName: getpassproductdata && getpassproductdata[i].gradeName,
          productName: getpassproductdata && getpassproductdata[i].productName,
 
          procurementQuantity:
            getpassproductdata && getpassproductdata[i].procurementQuantity,
          rate: (getpassproductdata && getpassproductdata[i].rate) ?? 0,
          status: getpassproductdata && getpassproductdata[i].status,
          createdDate:
            getpassproductdata && getpassproductdata[i].createdDate,
          gatepassId: getpassproductdata && getpassproductdata[i].gatepassId,
          cropId: getpassproductdata && getpassproductdata[i].cropId,
          varietyId: getpassproductdata && getpassproductdata[i].varietyId,
          productId: itemlistclass1[0].productId, //getpassproductdata && getpassproductdata[i].productId,
          gradeId: getpassproductdata && getpassproductdata[i].gradeId,
          unitId: getpassproductdata && getpassproductdata[i].unitId,
          orgId: getpassproductdata && getpassproductdata[i].orgId,
          createdBy: getpassproductdata && getpassproductdata[i].createdBy,
        });
      }


        console.log("newList", newList);
        calculateTotalProcuredQuantity(newList);

        setprocurmentProductdata([...newList]);
        console.log("newList", newList);
      }
    );
  };

  const { sendRequest: getpassIdProc } = useHttp();

  const { sendRequest: postProcurementReciept } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    //console.log("procurmentProductdata", procurmentProductdata);

    if (getpassproductdata.length == 0) {
      toast.error("Please enter at least one product!");
      setClose(true);
      return;
    }

    var zeroQtyProduct = procurmentProductdata.filter(
      (item) =>
        parseFloat(item.itemQuantity == "" ? "0" : item.itemQuantity) == 0
    );

    if (zeroQtyProduct.length == 3) {
      toast.error("Please enter quantity of the product!");
      setClose(true);
      return;
    }

    var rejectproce = false;
    if (frmRef.current.farmerType.value == "New Farmer") {
      rejectproce = frmRef.current.reject_procurement.checked ? true : false;
    }

    var validprocurmentProductdata = procurmentProductdata.filter(
      (item) =>
        parseFloat(item.itemQuantity == "" ? "0" : item.itemQuantity) > 0
    );

    setLoading(true);

    const data = {
      Date: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      procurementTime: frmRef.current.procurementTime.value,
      gatepassId: frmRef.current.getpassId.value,
      supervisorEmployeeId: assignEmployeeId,
      is_rejectProcurement: rejectproce,
      productDetails: validprocurmentProductdata,
      loadQuantity: totalProcuredQuantity,
      unitId: totalProcuredQuantityUnitId,
      status: 1,
      aqcStatus: false,
      lotStatus: false,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    console.log("data", data);
    if (props.update) {
      data["procurementRecieptId"] = props.update.procurementRecieptId;
    }
    postProcurementReciept(
      {
        url: "/api/procurementReciept/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        console.error("data", data);
        toast.success(
          `Procurement receipt detail ${props.update ? "updated" : "added"} `
        );
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error.response);

        const errorMessage =
        error.response && error.response.data && error.response.data.loadQuantity
          ? error.response.data.loadQuantity[0]
          : error.message || "An unexpected error occurred";

      toast.error(errorMessage);
        setLoading(false);
      }
    );
  };

  const handleValidateTotalQuantityChange = (index, event) => {
    var qua = parseFloat(event.target.value);

    var value = parseFloat(event.target.value);
    var totalqty = 0;

    var controlname = event.target.id;

    var grade1Qty = 0;
    var grade2Qty = 0;
    var grade3Qty = 0;

    if (controlname == "class1") grade1Qty = value;
    else grade1Qty = getpassproductdata[index].class1;

    if (controlname == "class2") grade2Qty = value;
    else grade2Qty = getpassproductdata[index].class2;

    if (controlname == "class3") grade3Qty = value;
    else grade3Qty = getpassproductdata[index].class3;

    var getpassQty = getpassproductdata[index].itemQuantity;

    totalqty =
      parseFloat(grade1Qty) + parseFloat(grade2Qty) + parseFloat(grade3Qty);

    if (totalqty > getpassQty) {
      toast.success(
        " Sum of all  grade quanitty cannot be greater than quantity",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );

      value = 0;
      event.target.value = 0;
      return;
    }

    if (controlname == "class1") getpassproductdata[index].class1 = value;
    else if (controlname == "class2") getpassproductdata[index].class2 = value;
    else if (controlname == "class3") getpassproductdata[index].class3 = value;
    console.log("getpassproductdata", getpassproductdata);
    setgetpassproductdata(getpassproductdata);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  useEffect(() => {
    frmRef.current.procurementTime.value = d.getHours() + ":" + d.getMinutes();
    //console.log("procurementTime", frmRef.current.procurementTime.value);
  }, [employeelist]);

  return (
    <>
      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div className="">
              <h3 className="card-title">Product Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div className="row">
              {frmRef.current.farmerType.value == "Existing Farmer" &&
              frmRef.current.procurementNo.value != "" ? (
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Crop Name </th>
                      <th>Variety Name</th>
                      <th>Grade</th>
                      <th>Item</th>
                      <th> Quantity</th>
                      <th>Unit</th>
                      <th>Procurement Quantity</th>
                      <th>Unit</th>
                      <th>Rate ({currencyCode})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {procurmentProductdata &&
                      procurmentProductdata.map((itm, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{itm.cropName}</td>
                            {/* <td>{itm.itemDescription}</td> */}
                            <td>{itm.varietyName}</td>
                            <td>{itm.gradeName}</td>
                            <td>{itm.productName}</td>
                            <td>{itm.procurementQuantity}</td>
                            <td>{itm.unitAbbreviation}</td>
                            <td className="">
                              <input
                                type={"number"}
                                id={"itemQuantity"}
                                defaultValue={itm.itemQuantity}
                                required
                                ref={(el) =>
                                  (frmRef.current["itemQuantity"] = el)
                                }
                                className="form-control text-right"
                                onChange={(e) => {
                                  getpassproductdata[i].itemQuantity =
                                    e.target.value;
                                  setgetpassproductdata(getpassproductdata);
                                }}
                              />
                            </td>
                            <td>{itm.unitAbbreviation}</td>

                            <td>{itm.rate}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              ) : (
                <table className="table table-bordered table-responsive text-center">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Crop Name </th>
                      <th>Variety Name</th>
                      <th>Quantity</th>
                      <th>Unit</th>
                      <th>Grade 1</th>
                      <th>Grade 2</th>
                      <th>Grade 3</th>
                      <th>Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getpassproductdata &&
                      getpassproductdata.map((itm, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{itm.cropName}</td>
                            {/* <td>{itm.itemDescription}</td> */}
                            <td>{itm.varietyName}</td>

                            <td>{itm.itemQuantity}</td>
                            <td>{itm.unitAbbreviation}</td>
                            <td>
                              <input
                                type={"text"}
                                id={"class1"}
                                required
                                ref={(el) => (frmRef.current["class1"] = el)}
                                className="inputs"
                                defaultValue={getpassproductdata[i].class1}
                                onChange={(e) => {
                                  handleValidateTotalQuantityChange(i, e);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type={"text"}
                                id={"class2"}
                                required
                                ref={(el) => (frmRef.current["class2"] = el)}
                                className="inputs"
                                defaultValue={getpassproductdata[i].class2}
                                onChange={(e) => {
                                  handleValidateTotalQuantityChange(i, e);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type={"text"}
                                id={"class3"}
                                defaultValue={getpassproductdata[i].class3}
                                required
                                ref={(el) => (frmRef.current["class3"] = el)}
                                className="inputs"
                                onChange={(e) => {
                                  handleValidateTotalQuantityChange(i, e);
                                }}
                              />
                            </td>
                            <td>{itm.unitAbbreviation}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              )}
            </div>

            <div className="row">
              <div className="col-md-4"> </div>
              <div className="col-md-1"> </div>
              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    console.log("Add button", "Add button");

                    if (
                      frmRef.current.farmerType.value == "New Farmer" ||
                      frmRef.current.farmerType.value == "Employee" ||
                      frmRef.current.farmerType.value == "Existing Farmer" ||
                      frmRef.current.procurementNo.value == ""
                    ) {
                      console.log("addToProcurmentList");
                      addToProcurmentList();
                    } else {
                      console.log("calculateTotalProcuredQuantity");
                      calculateTotalProcuredQuantity(procurmentProductdata);
                    }
                    //console.log("procurmentProductdata", procurmentProductdata);

                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>

              <div className="col-md-1"> </div>
              <div className="col-md-4"> </div>
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title"> Procurement Reciept Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"procurementTime"}>
                        {"procurement Time"}
                      </label>
                      <input
                        type={"time"}
                        id={"procurementTime"}
                        required
                        ref={(el) => (frmRef.current["procurementTime"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>
                        {"Assigned Supervisor Employee"}
                      </label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"getpassId"}>{"Gate Pass id"}</label>
                      <select
                        // onChange={gatPassId}
                        id="getpassId"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["getpassId"] = el)}
                        onChange={(e) => {
                          loadgetpassData(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Getpass--
                        </option>
                        {getpassData &&
                          getpassData.map((x) => (
                            <option key={x.getpassId} value={x.gatepassId}>
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"farmerType"}> {"Farmer Type"}</label>
                      <input
                        type={"text"}
                        id={"farmerType"}
                        readOnly="True"
                        ref={(el) => (frmRef.current["farmerType"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"farmerName"}> {"Farmer Name"}</label>
                      <input
                        type={"text"}
                        id={"farmerName"}
                        readOnly="True"
                        ref={(el) => (frmRef.current["farmerName"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"farmer_name"}> {"Procurement No"}</label>
                      <input
                        type={"text"}
                        id={"procurementNo"}
                        readOnly="True"
                        ref={(el) => (frmRef.current["procurementNo"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      <button
                        type={"button"}
                        id={"Product_details"}
                        required={productDetails ? false : true}
                        onClick={(e) => {
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setClose(true);
                        }}
                        className="btn btn-sm  btn-secondary mx-2 my-2"
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-4">
                      {rejectdisabled == false ? (
                        <label htmlFor={"reject_procurement"}>
                          {"Reject Procurement"}
                        </label>
                      ) : (
                        <span></span>
                      )}

                      {rejectdisabled == false ? (
                        <input
                          type={"checkbox"}
                          id={"reject_procurement"}
                          ref={(el) =>
                            (frmRef.current["reject_procurement"] = el)
                          }
                          className="checkbox form-control"

                          // onClick={setprocurement}
                        />
                      ) : (
                        <span></span>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"procuredQuantity"}>
                        {"Procured Quantity"}
                      </label>
                      <input
                        type={"text"}
                        id={"procuredQuantity"}
                        value={totalProcuredQuantity}
                        required
                        ref={(el) => (frmRef.current["procuredQuantity"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"unit"}>{"Unit"}</label>
                      <input
                        type={"text"}
                        id={"unit"}
                        value={totalProcuredQuantityUnit}
                        required
                        ref={(el) => (frmRef.current["unit"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}&nbsp;&nbsp;
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default ProcurementRecieptForm;
